export enum BANNER_TYPES {
    DIAGNOSTIC = 'diagnostic_banner',
    SUBSCRIPTION = 'subscription_banner',
    CREATE_LESSON = 'create_lesson_banner',
}
